<template>
  <b-tabs class="mt-4">
    <b-tab title="Zmień Hasło">
      <b-form @submit.stop.prevent="changePassword" class="my-3 p-3 border form">
        <app-input type="password" :model="$schema.previousPassword"></app-input>
        <app-input type="password" :model="$schema.password"></app-input>
        <app-input type="password" :model="$schema.repeatPassword"></app-input>
        <b-form-group class="mt-2 text-right">
          <b-button type="submit" variant="success">Zmień hasło</b-button>
        </b-form-group>
      </b-form>
    </b-tab>
  </b-tabs>
</template>

<script>
import formMixin from '@/mixins/formMixin';
import schema from '@/schemas/userSettings.schema';
import { UserResource } from '../../resources/user.resource';

export default {
  mixins: [formMixin],
  schema,

  methods: {
    async changePassword() {
      try {
        if (this.$schema.$validateAll().length === 0) {
          const success = await UserResource.changePassword(this.$schema);
          if (success) {
            this.$schema.$model.password = '';
            this.$schema.$model.repeatPassword = '';
            this.$schema.$model.previousPassword = '';
            this.$schema.$reset();
            this.$notify({ type: 'success', title: 'Ustawienia', text: 'Pomyślnie zmieniono hasło' });
          } else {
            throw new Error();
          }
        }
      } catch (error) {
        console.warn(error);
        this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas zmiany hasła' });
      }
    }
  }
};
</script>

<style>
.form {
  margin: auto;
  max-width: 400px;
}
</style>
